import { render, staticRenderFns } from "./category-selector.vue?vue&type=template&id=12506586"
import script from "./category-selector.vue?vue&type=script&lang=js"
export * from "./category-selector.vue?vue&type=script&lang=js"
import style0 from "./category-selector.vue?vue&type=style&index=0&id=12506586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports